<template>
  <div class='dialog'>
    <div class="dialog-content-wrap">
      <div class="protocol dialog-content">
        <div class="protocol-header">
          <span class="left">{{header}}</span>
          <em v-if="closeBtn" class="close" @click="close"></em>
        </div>
        <div class="title">
          <slot name="title" ></slot>
        </div>
        <div class="con">
          <slot></slot>
        </div>
        <div class="btnagrees" v-if="sign">
          <el-button type="primary" size="small" @click="disagree">不同意</el-button>
          <el-button type="primary" size="small" @click="agree">同 意</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'protocol-dialog',
    props :{
      header : {
        type : String,
        default : '用户协议'
      },
      sign: {
        type: Boolean,
        default: true,
      },
      closeBtn: {
        type: Boolean,
        default: false,
      }
    },

    methods : {
      close() {
        this.$emit('close');
      },
      agree() {
        this.$emit('agree');
      },
      disagree () {
        this.$emit('disagree');
      }
    }
  };
</script>